import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalCellular0Bar = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M20 6.83V20H6.83zM22 2 2 22h20z" />
  </svg>
)
export default SvgSignalCellular0Bar
